import { EquipmentModes, EquipmentStatuses } from '../../core/openapi/bff-admin-api';

export const MIN_DISPLAYABLE_UPTIME_SECONDS = 10;

export function getCorrectedEquipmentUptime(
  uptime: number | null | undefined,
  collectedAt: string | null | undefined,
  nowTimestampMs: number = Date.now(),
): number | null {
  if (typeof uptime !== 'number' || !Number.isFinite(uptime)) {
    return null;
  }

  const normalizedUptime = Math.max(0, Math.floor(uptime));
  const collectedAtTimestamp = collectedAt ? Date.parse(collectedAt) : Number.NaN;

  if (Number.isNaN(collectedAtTimestamp)) {
    return normalizedUptime;
  }

  const elapsedSeconds = Math.max(0, Math.floor((nowTimestampMs - collectedAtTimestamp) / 1000));

  return normalizedUptime + elapsedSeconds;
}

export function shouldDisplayEquipmentUptime(
  uptime: number | null | undefined,
  status: EquipmentStatuses | null | undefined,
  mode: EquipmentModes | null | undefined,
): uptime is number {
  return (
    typeof uptime === 'number' &&
    Number.isFinite(uptime) &&
    uptime >= MIN_DISPLAYABLE_UPTIME_SECONDS &&
    (status === EquipmentStatuses.Working || mode === EquipmentModes.Sleep)
  );
}
